import { Icon, Menu, MenuItem, Popover, Position, Button, Colors } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import { lang } from 'botpress/shared'
import React, { useState } from 'react'
import style from './style.scss'

const UTIL_URL = process.env.REACT_APP_UTIL_URL ? `${process.env.REACT_APP_UTIL_URL}/` : 'http://localhost:7001/utils/'
const DOCS_LINK = `${UTIL_URL}user-manual`

export const HelpMenu = props => {
  return (
    <div id="help_dropdown">
      <Popover
        content={
          <Menu>
            {/* <MenuItem icon="people" text={lang.tr('forum')} onClick={() => window.open(FORUM_LINK, '_blank')} /> */}
            <MenuItem icon="book" text={lang.tr('docs')} onClick={() => window.open(DOCS_LINK, '_blank')} />
          </Menu>
        }
        minimal
        target={
          <Tooltip2 content={<div className={style.tooltip}>{lang.tr('help')}</div>}>
            <Button minimal>
              <Icon color={Colors.WHITE} icon="help" iconSize={16} />
            </Button>
          </Tooltip2>
        }
        position={Position.TOP_RIGHT}
        canEscapeKeyClose
        fill
        modifiers={{
          preventOverflow: { enabled: true, boundariesElement: 'window' }
        }}
      />
    </div>
  )
}
